import {BrandType} from "../../definitions/types";
import {BrandModel} from "../domain/brandModel";

export class BrandLogoModel {
    private readonly _brand?: BrandModel;

    constructor(public readonly brandType?: BrandType) {
        this._brand = brandType ? new BrandModel(brandType) : undefined;
    }

    /**
     * @method brand
     * @description Returns the brand of the brand logo if it exists.
     * @returns {BrandModel | {image: undefined; name: undefined; link: undefined; description: undefined; id: undefined}}
     */
    public get brand(): BrandModel | {
        image: undefined;
        name: undefined;
        link: undefined;
        description: undefined;
        id: undefined
    } {
        return this._brand ?? {
            id: undefined,
            name: undefined,
            description: undefined,
            link: undefined,
            image: undefined
        }
    }
}